export const scratchEventType = {
  GET_SCRATCH_EVENT_REQUEST: "GET_SCRATCH_EVENT_REQUEST",
  GET_SCRATCH_EVENT_SUCCESS: "GET_SCRATCH_EVENT_SUCCESS",
  GET_SCRATCH_EVENT_FAIL: "GET_SCRATCH_EVENT_FAIL",
  UPDATE_STATUS_REQUEST: "UPDATE_STATUS_REQUEST",
  UPDATE_STATUS_SUCCESS: "UPDATE_STATUS_SUCCESS",
  UPDATE_STATUS_FAIL: "UPDATE_STATUS_FAIL",
  CREATE_SCRATCH_EVENT_REQUEST: "CREATE_SCRATCH_EVENT_REQUEST",
  CREATE_SCRATCH_EVENT_SUCCESS: "CREATE_SCRATCH_EVENT_SUCCESS",
  CREATE_SCRATCH_EVENT_FAIL: "CREATE_SCRATCH_EVENT_FAIL",
  UPDATE_SCRATCH_EVENT_REQUEST: "UPDATE_SCRATCH_EVENT_REQUEST",
  UPDATE_SCRATCH_EVENT_SUCCESS: "UPDATE_SCRATCH_EVENT_SUCCESS",
  UPDATE_SCRATCH_EVENT_FAIL: "UPDATE_SCRATCH_EVENT_FAIL",
  GET_SINGLE_SCRATCH_EVENT_REQUEST: "GET_SINGLE_SCRATCH_EVENT_REQUEST",
  GET_SINGLE_SCRATCH_EVENT_SUCCESS: "GET_SINGLE_SCRATCH_EVENT_SUCCESS",
  GET_SINGLE_SCRATCH_EVENT_FAIL: "GET_SINGLE_SCRATCH_EVENT_FAIL",
  DELETE_SINGLE_SCRATCH_EVENT_REQUEST: "DELETE_SINGLE_SCRATCH_EVENT_REQUEST",
  DELETE_SINGLE_SCRATCH_EVENT_SUCCESS: "DELETE_SINGLE_SCRATCH_EVENT_SUCCESS",
  DELETE_SINGLE_SCRATCH_EVENT_FAIL: "DELETE_SINGLE_SCRATCH_EVENT_FAIL",
  GET_USER_SCRATCH_EVENT_LIST_REQUEST: "GET_USER_SCRATCH_EVENT_LIST_REQUEST",
  GET_USER_SCRATCH_EVENT_LIST_SUCCESS: "GET_USER_SCRATCH_EVENT_LIST_SUCCESS",
  GET_USER_SCRATCH_EVENT_LIST_FAIL: "GET_USER_SCRATCH_EVENT_LIST_FAIL",
  GET_SCRATCH_EVENT_DROPDOWN_REQUEST: "GET_SCRATCH_EVENT_DROPDOWN_REQUEST",
  GET_SCRATCH_EVENT_DROPDOWN_SUCCESS: "GET_SCRATCH_EVENT_DROPDOWN_SUCCESS",
  GET_SCRATCH_EVENT_DROPDOWN_FAIL: "GET_SCRATCH_EVENT_DROPDOWN_FAIL",
  CHANGE_CUSTOMER_TAB: "CHANGE_CUSTOMER_TAB"
};
